<template>
	<el-row>
		<el-button type="primary" size="mini" @click="add()">+添加</el-button>
		<el-row style="margin: 10px 0;">
			<el-col :span="4">
				<div class="search-view">
					<div>
						课程名称:
					</div>
					<el-input placeholder="课程名称搜索" size="mini" v-model="lessonName" />
				</div>
			</el-col>
			<el-col :span="6">
				<div class="search-view">
					<div>
						状态:
					</div>
					<el-select size="mini" v-model="status" clearable placeholder="全部">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button type="primary" size="mini" style="margin-left: 10px;" @click="sx">筛选</el-button>
				</div>
			</el-col>
		</el-row>
		<el-table :data="tableDate" style="margin-top: 20px;">
			<el-table-column label="序号" width="50px" prop="id">
			</el-table-column>
			<el-table-column label="课程名称" prop="lessonName"></el-table-column>
			<el-table-column label="所属分类" prop="courseCategoryName"></el-table-column>
			<el-table-column label="关联栏目" prop="columnName"></el-table-column>
			<el-table-column label="排序" prop="sort"></el-table-column>
			<el-table-column label="状态" prop="status">
				<template slot-scope="scope">
					<el-switch class="tableScopeSwitch" :active-value="0" :inactive-value="1"
						@change="handleStatusChange(scope.row)" active-text="正常" inactive-text="禁用"
						v-model="scope.row.status">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="添加时间" prop="created"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
					<el-button type="text" size="mini" @click="bianji(scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>

		<el-dialog title="修改" :visible.sync="centerDialogVisible" width="25%" center>
			<el-form ref="info" :model="info" label-position="right" label-width="80px">
				<el-form-item label="关联栏目" prop="columnId" :rules="[{ 
					required: true, message: '请选择关联栏目', trigger: 'blur' }]">
					<el-select size="mini" v-model="info.columnId" clearable placeholder="全部">
						<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="排序" prop="sort" :rules="[{ 
					required: true, message: '请输入排序', trigger: 'blur' 
					}]">
					<el-input-number v-model="info.sort" :min="1"></el-input-number>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='queren'>确认</el-button>
					<el-button type="infor" @click="centerDialogVisible = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				total: 0,
				pageNum: 1,
				pageSize: 30,
				pagelist: [30, 50, 100],
				status: '',
				lessonName: '',
				tableDate: [],
				centerDialogVisible: false,
				options: [{
						value: "",
						label: '全部'
					}, {
						value: 0,
						label: '正常'
					},
					{
						value: 1,
						label: '禁用'
					}
				],
				options2: [],
				info: {
					id: "",
					sort: "",
					columnId: "",
					status: "",
					deleteStatus: ""
				}
			}
		},
		methods: {
			add() {
				this.$router.push({
					path: './add',
					query: {
						id: this.$route.query.id
					}
				})
			},
			bianji(row) {
				console.log(row);
				this.options2 = []
				this.$http.get(
						`/api/course/SiteManageController/selectAllColumnByAreaId?areaId=${this.$route.query.id}`, {})
					.then(res => {
						console.log(res.data.data.data);
						res.data.data.data.forEach(i => {
							this.options2.push({
								value: i.id,
								label: i.name,
							})
						})
					})
				this.centerDialogVisible = true
				this.info.sort = row.sort
				this.info.columnId = row.columnId
				this.info.id = row.id
				this.info.columnId = row.columnId //选择栏目的id
				this.info.status = row.columnId
				this.info.deleteStatus = row.columnId
			},
			sx() {
				this.getInfo()
			},
			del(row) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`/api/course/SiteManageController/updateAreaByLesson`, {
						deleteStatus: 1,
						id: row.id
					}).then(res => {
						console.log(res);
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.getInfo()
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			queren() {
				this.$refs.info.validate((vai) => {
					if (vai) {
						this.$http.post(`/api/course/SiteManageController/updateAreaByLesson`, {
							id: this.info.id,
							sort: this.info.sort,
							columnId: this.info.columnId,
						}).then(res => {
							console.log(res.data.data);
							if (res.data.data.status == 0) {
								this.$message.success(res.data.data.data)
								this.centerDialogVisible = false
								this.getInfo()
							} else {
								this.$message.error(res.data.data.msg)
							}
						})
					}
				})
			},
			handleStatusChange(row) {
				console.log(row.status);
				this.$http.post(`/api/course/SiteManageController/updateAreaByLesson`, {
					id: row.id,
					status: row.status == 1 ? 1 : 0
				}).then(res => {
					console.log(res.data.data);
				})
			},
			getInfo() {
				this.$http.get(
					`/api/course/SiteManageController/selectAreaByLesson?id=${this.$route.query.id}&pageSize=${this.pageSize}&pageNum=${this.pageNum}&status=${this.status}&lessonName=${this.lessonName}`
				).then(res => {
					console.log(res.data.data.data.list);
					this.tableDate = res.data.data.data.list
					this.total = res.data.data.data.total
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">
	/deep/.el-input-number__increase {
		right: -38px;
	}
</style>
